// Grey "no photo" profile placeholder (head + shoulders silhouette), the same idea as
// a Facebook default profile picture. Sized by its parent via className.
export default function DefaultAvatar({ className = "w-full h-full" }) {
  return (
    <svg
      viewBox="0 0 100 100"
      className={className}
      role="img"
      aria-label="No photo"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="100" height="100" fill="#e4e6eb" />
      <circle cx="50" cy="38" r="17" fill="#b0b3b8" />
      <path d="M14 100c0-22 16-36 36-36s36 14 36 36z" fill="#b0b3b8" />
    </svg>
  );
}
